module.exports = __webpack_public_path__ + "img/upload-guide-image.9d64b01a.png";